import { Button, Result } from 'antd';
import { useNavigate } from 'react-router-dom';

function NotFoundPage() {
	const navigate = useNavigate();

	const handleNavigateBack = () => {
		navigate(-1);
	};

	return (
		<Result
			status="404"
			title="404"
			style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%,-50%)' }}
			subTitle="Sorry, the page you visited does not exist."
			extra={
				<Button type="primary" onClick={handleNavigateBack}>
					Go Back
				</Button>
			}
		/>
	);
}

export default NotFoundPage;
